import { useState } from 'react'
import { withTranslate } from '@i18n/utils'
import FormsyInput from '@components/Textfield/withFormsy'
import Select from '@components/Select/RequiredSelectWithFormsy'
import {
    CAPostalCodeRegex,
    CAPostalCodeRegexString,
    countries,
    getCountryValue,
    getStates,
    getStateValue,
} from 'shared/states'
import { CURRENT_COUNTRY_CANADA } from 'shared/constants'

const AddressForm = ({ prefix, data, fieldsDisabled, type, translate: t }) => {
    const [selectedCountry, setSelectedCountry] = useState(data?.address?.country)

    return (
        <>
            <FormsyInput value={type} name={`${prefix}.address.type`} type="hidden" />
            <FormsyInput
                value={data?.address?.addressee}
                name={`${prefix}.address.addressee`}
                required
                placeholder={t('dashboard.account.addressee')}
                validationError={t('dashboard.account.addressee.invalid')}
                className="mb-3"
                disabled={fieldsDisabled}
            />
            <FormsyInput
                value={data?.address?.line1}
                name={`${prefix}.address.line1`}
                required
                placeholder={t('dashboard.account.address1')}
                validationError={t('dashboard.account.address1.invalid')}
                className="mb-3"
                disabled={fieldsDisabled}
            />
            <FormsyInput
                value={data?.address?.line2}
                name={`${prefix}.address.line2`}
                placeholder={t('dashboard.account.address2')}
                validationError={t('dashboard.account.address2.invalid')}
                className="mb-3"
                disabled={fieldsDisabled}
            />
            <FormsyInput
                value={data?.address?.city}
                name={`${prefix}.address.city`}
                required
                placeholder={t('dashboard.account.city')}
                validationError={t('dashboard.account.city.invalid')}
                className="mb-3"
                disabled={fieldsDisabled}
            />
            <FormsyInput
                value={data?.address?.zip?.toUpperCase()}
                uppercase
                name={`${prefix}.address.zip`}
                required
                placeholder={t('dashboard.account.postalCode')}
                className="mb-3"
                disabled={fieldsDisabled}
                validationError={t('dashboard.account.postalCode.ca.invalid')}
                pattern={selectedCountry === CURRENT_COUNTRY_CANADA ? CAPostalCodeRegexString : null}
                validations={
                    selectedCountry === CURRENT_COUNTRY_CANADA && {
                        matchRegexp: CAPostalCodeRegex,
                    }
                }
            />

            <div className="mb-3">
                <Select
                    options={getStates(selectedCountry)}
                    isSearchable={true}
                    getSelectValue={getStateValue(selectedCountry)}
                    value={data?.address?.state}
                    name={`${prefix}.address.state`}
                    placeholder={t('dashboard.account.state')}
                    isDisabled={fieldsDisabled}
                    required
                />
            </div>
            <div className="mb-3">
                <Select
                    options={countries}
                    onChange={setSelectedCountry}
                    isSearchable={true}
                    getSelectValue={getCountryValue}
                    value={selectedCountry}
                    name={`${prefix}.address.country`}
                    placeholder={t('dashboard.account.country')}
                    required
                />
            </div>
        </>
    )
}

export default compose(withTranslate)(AddressForm)
